import { render, staticRenderFns } from "./Xsck.vue?vue&type=template&id=68232718&scoped=true&"
import script from "./Xsck.vue?vue&type=script&lang=js&"
export * from "./Xsck.vue?vue&type=script&lang=js&"
import style0 from "./Xsck.vue?vue&type=style&index=0&id=68232718&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68232718",
  null
  
)

export default component.exports